// extracted by mini-css-extract-plugin
export var borderRadius = "_ao-4";
export var large = "_ao-3";
export var logoContainer = "_ao-0";
export var nameLogo = "_ao-2";
export var small = "_ao-1";